<template>
  <section class="flex flex-col h-full  min-h-0">
    <core-modal-header class="shrink-0">Bulk Photo Rotation</core-modal-header>

    <core-modal-body class="flex-1 min-h-0 flex flex-col">
      <div class="flex gap-3 justify-center items-center mb-3">
        <u-button label="Rotate All Left" icon="i-ri-anticlockwise-line" @click="rotateAll(-90)" color="charcoal" class="opacity-85 hover:opacity-100 transition-opacity" />
        <u-button label="Rotate All Right" icon="i-ri-clockwise-line" @click="rotateAll(90)" color="charcoal" class="opacity-85 hover:opacity-100 transition-opacity" />
      </div>

      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 flex-1 overflow-y-auto overflow-x-hidden scrollbar-light -mr-2.5 lg:-mr-3 lg:pr-3">
        <div v-for="file in filesToEdit" :key="file.id">
          <div class="relative bg-gray-100 border border-gray-300 p-3 rounded overflow-hidden">
            <div class="transition-transform rounded" :style="{
              backgroundImage: `url(${file.images.preview})`,
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              width: '100%',
              paddingBottom: '100%',
              transform: `rotate(${file.images.rotation}deg)`
            }" />
            <div class="flex gap-3 justify-between absolute left-3 right-3 bottom-3">
              <u-button
                color="charcoal"
                @click="rotateFile(file, -90)"
                icon="i-ri-anticlockwise-line"
                class="opacity-45 hover:opacity-100 transition-opacity"
              />
              <u-button
                color="charcoal"
                @click="rotateFile(file, 90)"
                icon="i-ri-clockwise-line"
                class="opacity-45 hover:opacity-100 transition-opacity"
              />
            </div>
          </div>
        </div>
      </div>
    </core-modal-body>

    <core-modal-footer class="shrink-0">
      <u-button size="xl" color="charcoal" variant="soft" @click="close">Cancel</u-button>
      <u-button size="xl" :loading="isBusy" @click="save" :disabled="Boolean(!updatedFiles.length)">Save Changes</u-button>
    </core-modal-footer>

  </section>
</template>

<script setup>
  const emit = defineEmits(['success'])
  const props = defineProps({
    files: Array,
    modal: Object
  });

  const filesStore = useFilesStore();
  const isBusy = ref(false);
  const eventBus = useEventBus('core-loading-set');

  const filesToEdit = ref(props.files.filter(file => file.is.photo).map(file => {
    let url = file.images.preview;
    if (file.is.gif) {
      file.images.preview = updateQueryParameters(url, {format: null});
    }
    if (file.is.tif) {
      file.images.preview = updateQueryParameters(url, {format: 'jpg'});
    }
    return {
      ...file,
      images: {
        ...file.images,
        rotation: file.images.rotation || 0
      }
    };
  }));

  const updatedFiles = computed(() => filesToEdit.value.filter(file => file.dirty));

  function rotateFile (file, degrees) {
    file.images.rotation = ((file.images.rotation || 0) + degrees);
    file.dirty = true;
  }

  function rotateAll (degrees) {
    filesToEdit.value.forEach(file => rotateFile(file, degrees));
  }

  async function save () {
    try {
      isBusy.value = true;eventBus.emit({
        isLoading: true,
        message: `Saving Changes`
      });
      await filesStore.updateFilesRotation({files: updatedFiles.value});

      useSuccessToast().add({
        id: 'files-rotation-success',
        description: updatedFiles.value.length > 1
          ? `${updatedFiles.value.length} photos were rotated.`
          : `The photo ${updatedFiles.value[0].name} was rotated.`
      });

      eventBus.emit({
        isLoading: false
      })

      emit('success');

    } catch (e) {
      useErrorToast().add();
      throw e;
    } finally {
      isBusy.value = false;
    }
  }

  function close() {
    props.modal.close();
  }

</script>
